import React, { useState } from 'react';

// Forest Animal SVG Avatars - matching the warm, friendly owl logo style
// Each animal is a simple, cute illustration with earth tones

const ANIMAL_AVATARS = {
  bunny: {
    name: 'Bunny',
    emoji: '🐰',
    color: '#B8860B',
    bgColor: '#FFF0F5',
    image: '/avatars/bunny.png',
    svg: `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="38" r="22" fill="#E8D5C4"/>
      <ellipse cx="24" cy="10" rx="6" ry="18" fill="#E8D5C4" transform="rotate(-10 24 10)"/>
      <ellipse cx="40" cy="10" rx="6" ry="18" fill="#E8D5C4" transform="rotate(10 40 10)"/>
      <ellipse cx="24" cy="10" rx="3" ry="14" fill="#F5C6D0" transform="rotate(-10 24 10)"/>
      <ellipse cx="40" cy="10" rx="3" ry="14" fill="#F5C6D0" transform="rotate(10 40 10)"/>
      <circle cx="25" cy="34" r="3" fill="#4A3520"/>
      <circle cx="39" cy="34" r="3" fill="#4A3520"/>
      <circle cx="26" cy="33" r="1" fill="white"/>
      <circle cx="40" cy="33" r="1" fill="white"/>
      <ellipse cx="32" cy="40" rx="3" ry="2" fill="#F5C6D0"/>
      <path d="M29 42 Q32 46 35 42" fill="none" stroke="#4A3520" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="22" cy="40" r="4" fill="#F5C6D0" opacity="0.5"/>
      <circle cx="42" cy="40" r="4" fill="#F5C6D0" opacity="0.5"/>
    </svg>`
  },
  fox: {
    name: 'Fox',
    emoji: '🦊',
    color: '#D2691E',
    bgColor: '#FFF5EE',
    image: '/avatars/fox.png',
    svg: `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="36" r="22" fill="#D4712A"/>
      <path d="M14 16 L20 30 L10 28 Z" fill="#D4712A"/>
      <path d="M50 16 L44 30 L54 28 Z" fill="#D4712A"/>
      <path d="M15 17 L20 28 L12 27 Z" fill="#E8D5C4"/>
      <path d="M49 17 L44 28 L52 27 Z" fill="#E8D5C4"/>
      <ellipse cx="32" cy="42" rx="12" ry="10" fill="#FFF8E7"/>
      <circle cx="25" cy="32" r="3" fill="#4A3520"/>
      <circle cx="39" cy="32" r="3" fill="#4A3520"/>
      <circle cx="26" cy="31" r="1" fill="white"/>
      <circle cx="40" cy="31" r="1" fill="white"/>
      <ellipse cx="32" cy="38" rx="3" ry="2" fill="#2A1F14"/>
      <path d="M29 42 Q32 45 35 42" fill="none" stroke="#4A3520" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`
  },
  deer: {
    name: 'Deer',
    emoji: '🦌',
    color: '#A0522D',
    bgColor: '#FAF0E6',
    image: '/avatars/deer.png',
    svg: `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="38" r="20" fill="#C4874A"/>
      <path d="M20 14 L18 4 L16 8 L14 2 L20 12 Z" fill="#8B6234"/>
      <path d="M44 14 L46 4 L48 8 L50 2 L44 12 Z" fill="#8B6234"/>
      <ellipse cx="32" cy="44" rx="10" ry="8" fill="#E8D5C4"/>
      <circle cx="25" cy="34" r="3" fill="#4A3520"/>
      <circle cx="39" cy="34" r="3" fill="#4A3520"/>
      <circle cx="26" cy="33" r="1" fill="white"/>
      <circle cx="40" cy="33" r="1" fill="white"/>
      <ellipse cx="32" cy="42" rx="3" ry="2" fill="#2A1F14"/>
      <path d="M29 46 Q32 49 35 46" fill="none" stroke="#4A3520" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="22" cy="38" r="3" fill="#E8A080" opacity="0.4"/>
      <circle cx="42" cy="38" r="3" fill="#E8A080" opacity="0.4"/>
    </svg>`
  },
  bear: {
    name: 'Bear',
    emoji: '🐻',
    color: '#6B4226',
    bgColor: '#F5E6D3',
    image: '/avatars/bear.png',
    svg: `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="36" r="22" fill="#8B6234"/>
      <circle cx="18" cy="18" r="8" fill="#8B6234"/>
      <circle cx="46" cy="18" r="8" fill="#8B6234"/>
      <circle cx="18" cy="18" r="5" fill="#A07848"/>
      <circle cx="46" cy="18" r="5" fill="#A07848"/>
      <ellipse cx="32" cy="42" rx="10" ry="8" fill="#C4A070"/>
      <circle cx="25" cy="32" r="3" fill="#2A1F14"/>
      <circle cx="39" cy="32" r="3" fill="#2A1F14"/>
      <circle cx="26" cy="31" r="1" fill="white"/>
      <circle cx="40" cy="31" r="1" fill="white"/>
      <ellipse cx="32" cy="38" rx="4" ry="3" fill="#2A1F14"/>
      <path d="M28 43 Q32 47 36 43" fill="none" stroke="#4A3520" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`
  },
  raccoon: {
    name: 'Raccoon',
    emoji: '🦝',
    color: '#696969',
    bgColor: '#F0F0F0',
    image: '/avatars/raccoon.png',
    svg: `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="36" r="22" fill="#888888"/>
      <path d="M14 20 L18 28 L10 26 Z" fill="#888888"/>
      <path d="M50 20 L46 28 L54 26 Z" fill="#888888"/>
      <ellipse cx="32" cy="42" rx="12" ry="10" fill="#E0E0E0"/>
      <ellipse cx="25" cy="30" rx="7" ry="5" fill="#2A2A2A"/>
      <ellipse cx="39" cy="30" rx="7" ry="5" fill="#2A2A2A"/>
      <circle cx="25" cy="30" r="3" fill="white"/>
      <circle cx="39" cy="30" r="3" fill="white"/>
      <circle cx="25" cy="30" r="1.5" fill="#2A2A2A"/>
      <circle cx="39" cy="30" r="1.5" fill="#2A2A2A"/>
      <ellipse cx="32" cy="38" rx="3" ry="2" fill="#2A1F14"/>
      <path d="M29 42 Q32 45 35 42" fill="none" stroke="#4A3520" stroke-width="1.5" stroke-linecap="round"/>
    </svg>`
  },
  squirrel: {
    name: 'Squirrel',
    emoji: '🐿️',
    color: '#B5651D',
    bgColor: '#FFF5E6',
    image: '/avatars/squirrel.png',
    svg: `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="36" r="20" fill="#B5651D"/>
      <path d="M16 20 L14 12 L20 22 Z" fill="#B5651D"/>
      <path d="M48 20 L50 12 L44 22 Z" fill="#B5651D"/>
      <path d="M17 19 L16 14 L20 21 Z" fill="#D4A060"/>
      <path d="M47 19 L48 14 L44 21 Z" fill="#D4A060"/>
      <ellipse cx="32" cy="40" rx="10" ry="8" fill="#E8D5C4"/>
      <circle cx="25" cy="32" r="3.5" fill="#FFF8E7"/>
      <circle cx="39" cy="32" r="3.5" fill="#FFF8E7"/>
      <circle cx="25" cy="32" r="2" fill="#4A3520"/>
      <circle cx="39" cy="32" r="2" fill="#4A3520"/>
      <circle cx="26" cy="31.5" r="0.8" fill="white"/>
      <circle cx="40" cy="31.5" r="0.8" fill="white"/>
      <ellipse cx="32" cy="38" rx="2" ry="1.5" fill="#2A1F14"/>
      <circle cx="26" cy="40" r="3" fill="#E8A080" opacity="0.4"/>
      <circle cx="38" cy="40" r="3" fill="#E8A080" opacity="0.4"/>
    </svg>`
  },
  bluebird: {
    name: 'Bluebird',
    emoji: '🐦',
    color: '#4682B4',
    bgColor: '#F0F8FF',
    image: '/avatars/bluebird.png',
    svg: `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="36" r="20" fill="#5B9BD5"/>
      <ellipse cx="32" cy="42" rx="12" ry="10" fill="#B8D4E8"/>
      <circle cx="25" cy="30" r="4" fill="white"/>
      <circle cx="39" cy="30" r="4" fill="white"/>
      <circle cx="25" cy="30" r="2" fill="#2A2A3A"/>
      <circle cx="39" cy="30" r="2" fill="#2A2A3A"/>
      <circle cx="26" cy="29.5" r="0.8" fill="white"/>
      <circle cx="40" cy="29.5" r="0.8" fill="white"/>
      <path d="M30 36 L32 40 L34 36" fill="#E8A020" stroke="#C4862F" stroke-width="0.8"/>
      <path d="M18 22 Q12 18 16 14" fill="none" stroke="#5B9BD5" stroke-width="3" stroke-linecap="round"/>
      <path d="M46 22 Q52 18 48 14" fill="none" stroke="#5B9BD5" stroke-width="3" stroke-linecap="round"/>
    </svg>`
  },
  turtle: {
    name: 'Turtle',
    emoji: '🐢',
    color: '#2E8B57',
    bgColor: '#F0FFF0',
    image: '/avatars/turtle.png',
    svg: `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="32" cy="38" rx="24" ry="20" fill="#5C9A5C"/>
      <ellipse cx="32" cy="38" rx="20" ry="16" fill="#7AB87A"/>
      <path d="M20 30 L32 24 L44 30 L38 38 L32 42 L26 38 Z" fill="#5C9A5C" opacity="0.5"/>
      <ellipse cx="32" cy="26" rx="12" ry="10" fill="#8BC48A"/>
      <circle cx="27" cy="24" r="2.5" fill="#2A3A2A"/>
      <circle cx="37" cy="24" r="2.5" fill="#2A3A2A"/>
      <circle cx="28" cy="23.5" r="0.8" fill="white"/>
      <circle cx="38" cy="23.5" r="0.8" fill="white"/>
      <path d="M30 28 Q32 30 34 28" fill="none" stroke="#2A3A2A" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="26" cy="26" r="2.5" fill="#A0D4A0" opacity="0.4"/>
      <circle cx="38" cy="26" r="2.5" fill="#A0D4A0" opacity="0.4"/>
    </svg>`
  },
  otter: {
    name: 'Otter',
    emoji: '🦦',
    color: '#6B4226',
    bgColor: '#F5EDE3',
    image: '/avatars/otter.png',
    svg: `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="32" cy="36" rx="20" ry="22" fill="#7A5230"/>
      <circle cx="20" cy="20" r="6" fill="#7A5230"/>
      <circle cx="44" cy="20" r="6" fill="#7A5230"/>
      <ellipse cx="32" cy="42" rx="14" ry="12" fill="#D4B896"/>
      <circle cx="26" cy="30" r="3" fill="#FFF8E7"/>
      <circle cx="38" cy="30" r="3" fill="#FFF8E7"/>
      <circle cx="26" cy="30" r="1.5" fill="#2A1F14"/>
      <circle cx="38" cy="30" r="1.5" fill="#2A1F14"/>
      <ellipse cx="32" cy="36" rx="4" ry="2.5" fill="#2A1F14"/>
      <path d="M28 40 Q32 44 36 40" fill="none" stroke="#4A3520" stroke-width="1.5" stroke-linecap="round"/>
      <line x1="20" y1="36" x2="14" y2="34" stroke="#7A5230" stroke-width="1.5"/>
      <line x1="20" y1="38" x2="14" y2="38" stroke="#7A5230" stroke-width="1.5"/>
      <line x1="44" y1="36" x2="50" y2="34" stroke="#7A5230" stroke-width="1.5"/>
      <line x1="44" y1="38" x2="50" y2="38" stroke="#7A5230" stroke-width="1.5"/>
    </svg>`
  },
  hedgehog: {
    name: 'Hedgehog',
    emoji: '🦔',
    color: '#8B7355',
    bgColor: '#F5F0E8',
    image: '/avatars/hedgehog.png',
    svg: `<svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="36" r="22" fill="#8B7355"/>
      <path d="M16 20 L12 14 L18 18 M20 16 L18 8 L22 14 M26 14 L26 6 L28 12 M32 13 L34 4 L34 12 M38 14 L40 6 L38 12 M42 16 L46 8 L42 14 M46 20 L52 14 L46 18" stroke="#6B5335" stroke-width="2.5" stroke-linecap="round" fill="none"/>
      <ellipse cx="32" cy="42" rx="16" ry="14" fill="#E8D5C4"/>
      <circle cx="26" cy="34" r="3" fill="#2A1F14"/>
      <circle cx="38" cy="34" r="3" fill="#2A1F14"/>
      <circle cx="27" cy="33" r="1" fill="white"/>
      <circle cx="39" cy="33" r="1" fill="white"/>
      <ellipse cx="32" cy="40" rx="3" ry="2" fill="#2A1F14"/>
      <path d="M29 44 Q32 47 35 44" fill="none" stroke="#4A3520" stroke-width="1.5" stroke-linecap="round"/>
      <circle cx="24" cy="40" r="3" fill="#E8A080" opacity="0.3"/>
      <circle cx="40" cy="40" r="3" fill="#E8A080" opacity="0.3"/>
    </svg>`
  }
};

// Ordered list of animals for selection grid
const ANIMAL_LIST = ['bunny', 'fox', 'deer', 'bear', 'raccoon', 'squirrel', 'bluebird', 'turtle', 'otter', 'hedgehog'];

// Render an animal avatar - uses PNG image if available, falls back to SVG
function AnimalAvatar({ animal, size = 40, className = '' }) {
  const avatarData = ANIMAL_AVATARS[animal] || ANIMAL_AVATARS[ANIMAL_LIST[0]];
  
  if (avatarData.image) {
    return (
      <img 
        src={avatarData.image} 
        alt={avatarData.name}
        width={size} 
        height={size}
        className={`rounded-full object-cover ${className}`}
        style={{ background: avatarData.bgColor }}
      />
    );
  }

  const svgDataUri = `data:image/svg+xml,${encodeURIComponent(avatarData.svg)}`;
  
  return (
    <img 
      src={svgDataUri} 
      alt={avatarData.name}
      width={size} 
      height={size}
      className={`rounded-full ${className}`}
      style={{ background: avatarData.bgColor }}
    />
  );
}

// Avatar selection grid for signup/profile
function AvatarSelector({ selectedAnimal, onSelect, compact = false }) {
  const gridSize = compact ? 'grid-cols-5' : 'grid-cols-5';
  const avatarSize = compact ? 40 : 56;

  return (
    <div>
      <label className="block text-sm font-medium text-stone-700 mb-2">
        Choose your forest avatar
      </label>
      <div className={`grid ${gridSize} gap-2`}>
        {ANIMAL_LIST.map(key => {
          const avatar = ANIMAL_AVATARS[key];
          const isSelected = selectedAnimal === key;
          return (
            <button
              key={key}
              type="button"
              onClick={() => onSelect(key)}
              className={`flex flex-col items-center p-2 rounded-lg border-2 transition-all ${
                isSelected 
                  ? 'border-amber-500 bg-amber-50 shadow-md' 
                  : 'border-stone-200 hover:border-amber-300 hover:bg-stone-50'
              }`}
            >
              <AnimalAvatar animal={key} size={avatarSize} />
              <span className={`text-xs mt-1 font-medium ${isSelected ? 'text-amber-700' : 'text-stone-600'}`}>
                {avatar.name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

// Get display name for an animal (for Story Mode)
function getAnimalName(animal) {
  return ANIMAL_AVATARS[animal]?.name || 'Friend';
}

// Get avatar data
function getAnimalData(animal) {
  return ANIMAL_AVATARS[animal] || ANIMAL_AVATARS[ANIMAL_LIST[0]];
}

export { ANIMAL_AVATARS, ANIMAL_LIST, AnimalAvatar, AvatarSelector, getAnimalName, getAnimalData };
export default AnimalAvatar;
